<template>
  <pack class="cms-website-config" v-if="cms_activate">
    <zt-title>网站配置</zt-title>
    <el-tabs @tab-click="onTabChange" :value="current">
      <el-tab-pane label="CMS基本配置">
        <transition name="fade-transform" mode="out-in">
        <Base :info="cms_info"/>
        </transition>
      </el-tab-pane>
      <el-tab-pane label="CMS更多配置">
        <More :info="cms_info"/>
      </el-tab-pane>
      <el-tab-pane label="SEO配置">
        <Seo :info="cms_info"/>
      </el-tab-pane>
      <el-tab-pane label="功能显示配置" v-if="user_vip > 1">
        <display :info="cms_info"/>
      </el-tab-pane>
      <el-tab-pane label="弹屏广告">
        <Advert :info="cms_info"/>
      </el-tab-pane>
      <el-tab-pane label="轮播图设置">
        <Swiper :info="cms_info"/>
      </el-tab-pane>
      <el-tab-pane label="帮助中心">
        <Help/>
      </el-tab-pane>
      <el-tab-pane label="发送消息">
        <Message/>
      </el-tab-pane>
    </el-tabs>
  </pack>
  <unactivate v-else />
</template>

<script>
import Message from './components/config/Message'
import Help from './components/config/Help'
import Base from './components/config/Base'
import More from './components/config/More'
import Seo from './components/config/Seo'
import Advert from './components/config/advert'
import Swiper from './components/config/swiper'
import display from './components/config/display'
import unactivate from './components/Unactivate'

import { mapGetters } from 'vuex'

export default {
  name: 'CMSWebSiteConfig',
  components: { Base, More, Seo, unactivate, Advert, Swiper, display, Help, Message },
  computed: {
    current() {
      return this.$store.state.tabs.cmsConfigTabs
      // return 0
    },
    ...mapGetters([ 'cms_info', 'cms_activate', 'user_vip' ]),
  },
  methods: {
    onTabChange(e) {
      this.$store.dispatch('ChangeTabs', { name: 'cmsConfigTabs', current: e.index })
      this.$store.dispatch('GetCmsInfo')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
